import React, { useEffect, useState } from 'react'
import { AutoComplete } from 'primereact/autocomplete'
import { getClientesCte } from '../../../../../services/api/https/deliveries/cte.http'

import './SelectClienteTp.css'

// Clientes do TP buscados no servidor conforme o usuário digita (o TP pode ter milhares de cadastros,
// e carregar todos deixava o preenchimento do modal lento)
export default function SelectClienteTp({
  selectedTp,
  onSelect,
  onError,
  disabled = false,
  selecionado = null,
}) {
  const [valor, setValor] = useState(selecionado || '')
  const [sugestoes, setSugestoes] = useState([])
  const idSelecionado = selecionado ? selecionado.id : null

  // Mostra o cliente vindo das notas; o escolhido na busca mantém o rótulo dela
  useEffect(() => {
    setValor(atual =>
      atual && typeof atual === 'object' && atual.id === idSelecionado ? atual : selecionado || '',
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idSelecionado])

  const buscar = async event => {
    try {
      const clientes = await getClientesCte(selectedTp, event.query)
      setSugestoes(
        (clientes || []).map(cliente => ({
          ...cliente,
          rotulo: `${cliente.nome} - ${cliente.cnpj}`,
        })),
      )
    } catch (error) {
      setSugestoes([])
      onError(error)
    }
  }

  return (
    <div className="SelectClienteTp">
      <label className="autocomplete-label">Cliente:*</label>
      <AutoComplete
        value={valor}
        suggestions={sugestoes}
        completeMethod={buscar}
        field="rotulo"
        dropdown={true}
        dropdownMode="blank"
        minLength={2}
        delay={350}
        disabled={disabled}
        placeholder="Digite o nome ou o CNPJ do cliente"
        appendTo={document.body}
        onChange={event => setValor(event.value)}
        onSelect={event => {
          setValor(event.value)
          onSelect(event.value)
        }}
      />
      <span className="autocomplete-hint">
        Digite ao menos 2 caracteres ou use a seta para ver os primeiros clientes do TP.
      </span>
    </div>
  )
}
